// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"783":"a03b23c1","787":"9e9f4ffd","839":"84ee41c4"}[chunkId] + ".chunk.js";
};